// reducers/feeReducer.js
export const feeReducer = (state = {}, action) => {
  switch (action.type) {
    case "FEE_REQUEST":
      return { ...state, loading: true };
    case "FEE_STRUCTURE_SUCCESS":
      return { ...state, loading: false, structures: action.payload };
    case "STUDENT_FEE_SUCCESS":
      return {
        loading: false,
        payments: action.payload.payments,
        totalPaid: action.payload.totalPaid,
        totalDue: action.payload.totalDue, // ✅ now from backend
        totalExpected: action.payload.totalExpected, // ✅ new
        activeDiscount: action.payload.activeDiscount, // ✅ new
      };
    case "PENDING_FEE_SUCCESS":
      return { ...state, loading: false, pending: action.payload };
    case "FEE_REPORT_SUCCESS":
      return { ...state, loading: false, report: action.payload };
    case "COLLECT_FEE_SUCCESS":
      return { ...state, loading: false, success: true };
    case "FEE_FAIL":
      return { ...state, loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };
    default:
      return state;
  }
};
